import type {IABTestConfiguration} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

import {OngoingABTests} from "./ongoing_ab_tests_enum";

export const SEMANTIC_SEARCH_AB_TEST_ID = "semantic-search";

const SEMANTIC_SEARCH_NEW_FLOW_DEFAULT_VARIANT = "default" as const;
export const SEMANTIC_SEARCH_NEW_FLOW_VARIANT = "new-flow" as const;

// Cookie-based AB test (specifyABTestVariant) — variantConfig controls traffic split, no Amplitude Experiment.
export const semanticSearchAbTests: IABTestConfiguration = {
    id: SEMANTIC_SEARCH_AB_TEST_ID,
    name: OngoingABTests.SEMANTIC_SEARCH,
    expires: new Date(2027, 11, 31),
    // Homepage button and offer list floating sidebar
    path: [rpAppPath.base, rpAppPath.friendlyOfferList, rpAppPath.multiOfferList.base],
    variants: [SEMANTIC_SEARCH_NEW_FLOW_DEFAULT_VARIANT, SEMANTIC_SEARCH_NEW_FLOW_VARIANT],
    variantConfig: {
        [SEMANTIC_SEARCH_NEW_FLOW_DEFAULT_VARIANT]: 0.9,
        [SEMANTIC_SEARCH_NEW_FLOW_VARIANT]: 0.1
    },
    withSSR: true,
    matchOnAllPaths: false
};
import type {IABTestConfiguration} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

import {OngoingABTests} from "./ongoing_ab_tests_enum";

export const SEMANTIC_SEARCH_AB_TEST_ID = "semantic-search";

const SEMANTIC_SEARCH_NEW_FLOW_DEFAULT_VARIANT = "default" as const;
export const SEMANTIC_SEARCH_NEW_FLOW_VARIANT = "new-flow" as const;

// Cookie-based AB test (specifyABTestVariant) — variantConfig controls traffic split, no Amplitude Experiment.
export const semanticSearchAbTests: IABTestConfiguration = {
    id: SEMANTIC_SEARCH_AB_TEST_ID,
    name: OngoingABTests.SEMANTIC_SEARCH,
    expires: new Date(2027, 11, 31),
    // Homepage button and offer list floating sidebar
    path: [rpAppPath.base, rpAppPath.friendlyOfferList, rpAppPath.multiOfferList.base],
    variants: [SEMANTIC_SEARCH_NEW_FLOW_DEFAULT_VARIANT, SEMANTIC_SEARCH_NEW_FLOW_VARIANT],
    variantConfig: {
        [SEMANTIC_SEARCH_NEW_FLOW_DEFAULT_VARIANT]: 0.9,
        [SEMANTIC_SEARCH_NEW_FLOW_VARIANT]: 0.1
    },
    withSSR: true,
    matchOnAllPaths: false
};
